import css from "styled-jsx/css";

export const componentStyles = css.global`
  .multi-products-pricing-component {
    margin: auto;

    .product-switcher {
      margin-bottom: 390px;
    }

    .signup-form {
      .signup-button,
      .cta-button {
        background-color: var(--primary-color);
        letter-spacing: 0.4px;
        max-width: none;
        width: 100%;
        border: none;
        padding: 16px 24px;
        font-size: 16px;
        font-weight: 400;
      }
    }
    .signup-form:hover {
      .signup-button:hover,
      .cta-button:hover {
        background-color: var(--secondary-color);
      }
    }
  }
`;
